module.exports = __webpack_public_path__ + "static/media/beef5.99e4c9ea.jpg";